module.exports = __webpack_public_path__ + "close-button1.png?b8d7bf88428555c8f9bd0c4f261e63f2";


//////////////////
// WEBPACK FOOTER
// ./images/close-button1.png
// module id = 240
// module chunks = 0